import React from 'react';

import EmptyView from 'components/EmptyView';
import styles from './style.scss';

interface ISelection {
  page: number;
  name__icontains: string;
}

interface IProps {
  searchTerm: string;
  getProjects: (selection: ISelection) => void;
}

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */

const NoSearchResults = ({ searchTerm, getProjects }: IProps) => (
  <EmptyView className={styles['empty-view']}>
    <span className="icon-no-projects" />
    <p>You have no projects named &quot;{searchTerm}&quot;</p>
    <p>
      <a
        onClick={() =>
          getProjects({
            page: 1,
            name__icontains: '',
          })
        }
      >
        Show all
      </a>
    </p>
  </EmptyView>
);

export default NoSearchResults;
